import * as _env2 from "@shopify/app-bridge-core/util/env";
var _env = "default" in _env2 ? _env2.default : _env2;
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDevelopmentClient = exports.isProduction = exports.isDevelopment = exports.isUnframed = exports.isServer = exports.isClient = void 0;
var env_1 = _env;
var env_2 = _env;
Object.defineProperty(exports, "isClient", {
  enumerable: true,
  get: function () {
    return env_2.isClient;
  }
});
Object.defineProperty(exports, "isServer", {
  enumerable: true,
  get: function () {
    return env_2.isServer;
  }
});
Object.defineProperty(exports, "isUnframed", {
  enumerable: true,
  get: function () {
    return env_2.isUnframed;
  }
});
exports.isDevelopment = typeof process !== "undefined" && process.env && false;
exports.isProduction = !exports.isDevelopment;
exports.isDevelopmentClient = exports.isDevelopment && env_1.isClient;
export default exports;
export const __esModule = exports.__esModule,
  isDevelopmentClient = exports.isDevelopmentClient,
  isProduction = exports.isProduction,
  isDevelopment = exports.isDevelopment,
  isUnframed = exports.isUnframed,
  isServer = exports.isServer,
  isClient = exports.isClient;